<app-topbar></app-topbar>
<main class="layout-container">
  <p-toast></p-toast>  
  <div class="layout-content-wrapper">
    <router-outlet></router-outlet>
    <div class="layout-content-wrapper">
      <div class="layout-content">
        <!-- Barra de Ações -->
        <div class="block-content py-4">
          <div
            class="lg:px-8 md:px-6 px-4 flex gap-2 mb-2 align-items-center justify-content-between"
          >
            <!-- Barra de busca -->
            <div class="flex-1" style="min-width: 250px; flex-grow: 1">
              <div class="flex gap-2 relative input-container">
                <input
                  type="text"
                  placeholder="Digite o tipo de sentença ou documento que deseja..."
                  class="p-inputtext-lg w-full input-with-button"
                  pInputText
                  [(ngModel)]="searchValue"
                />
                <button
                  title="Buscar prompt"
                  class="btn-search"
                  (click)="onSearch()"
                >
                  <i class="pi pi-search"></i>
                </button>
              </div>
            </div>

            <!-- Dropdown de filtro -->
            <div
              class="flex align-items-center gap-2"
              style="margin-left: 16px"
            >
              <label>Filtrar por:</label>
              <p-dropdown
                [options]="filterOptions"
                [(ngModel)]="selectedFilter"
                placeholder="Selecione"
                styleClass="w-12rem"
              ></p-dropdown>
            </div>

            <!-- Dropdown de itens por página -->
            <div
              class="flex align-items-center gap-2"
              style="margin-left: 16px"
            >
              <label>Itens por página</label>
              <p-dropdown
                [options]="pageSizes"
                [(ngModel)]="size"
                (onChange)="onPageSizeChange($event)"
                placeholder="{{ size }}"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <!-- Tabela de Resultados -->
        <div class="block-content">
          <div class="lg:px-8 md:px-6 px-4">
            <p-table class="table-prompts"
              [value]="prompt"
              [responsiveLayout]="'scroll'"
              [tableStyle]="{ 'min-width': '60rem' }"
              dataKey="id"
              [expandedRowKeys]="expandedRows"
              [paginator]="true"
              [rows]="size"
              [totalRecords]="totalElements"
              [lazy]="true"
              [loading]="isLoading"
              (onLazyLoad)="onPageChange($event)"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3rem"></th>
                  <th (click)="onSortChange('title')">
                    Nome do Prompt
                    <i
                      [ngClass]="
                        sortField === 'title' && sortDirection === 'asc'
                          ? 'pi pi-sort-amount-up'
                          : sortField === 'title' && sortDirection === 'desc'
                          ? 'pi pi-sort-amount-down'
                          : 'pi pi-sort'
                      "
                    ></i>
                  </th>
                  <th (click)="onSortChange('login')">
                    Autor
                    <i
                      [ngClass]="
                        sortField === 'login' && sortDirection === 'asc'
                          ? 'pi pi-sort-amount-up'
                          : sortField === 'login' && sortDirection === 'desc'
                          ? 'pi pi-sort-amount-down'
                          : 'pi pi-sort'
                      "
                    ></i>
                  </th>
                  <th (click)="onSortChange('average')">
                    Avaliações
                    <i
                      [ngClass]="
                        sortField === 'average' && sortDirection === 'asc'
                          ? 'pi pi-sort-amount-up'
                          : sortField === 'average' && sortDirection === 'desc'
                          ? 'pi pi-sort-amount-down'
                          : 'pi pi-sort'
                      "
                    ></i>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item let-expanded="expanded">
                <tr>
                  <td>
                    <p-button
                      type="button"
                      pRipple
                      [pRowToggler]="item"
                      [text]="true"
                      [rounded]="true"
                      [plain]="true"
                      [icon]="
                        expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                      "
                    ></p-button>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.login }}</td>
                  <td>
                    <p-rating
                      [ngModel]="item.mediaAvaliacao"
                      readonly="true"
                      stars="5"
                      [cancel]="false"
                      styleClass="custom-rating"
                    ></p-rating>
                    <span
                      class="text-sm text-secondary"
                      style="position: relative; top: -4px; left: 6px"
                    >
                      ({{ item.totalAvaliacoes }} avaliações)
                    </span>
                  </td>
                </tr>
              </ng-template>

              <!-- Bloco restaurado para expansão -->
              <ng-template pTemplate="rowexpansion" let-item>
                <tr>
                  <td colspan="4">
                    <div class="p-4">
                      <div class="card">
                        <div class="card-header">Descrição</div>
                        <div class="card-content">{{ item.description }}</div>
                      </div>
                      <div class="card mt-3">
                        <div class="card-header">Comando</div>
                        <div class="card-content">
                          <pre>{{ item.command }}</pre>
                          <p-button
                            pRipple
                            type="button"
                            label="Copiar Comando"
                            icon="pi pi-copy"
                            severity="success"
                            class="mt-2"
                            (click)="copiarTexto(item.command)"
                          ></p-button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
